export var AccessPermission;
(function (AccessPermission) {
    AccessPermission[AccessPermission["Write"] = 2] = "Write";
    AccessPermission[AccessPermission["ReadOnly"] = 4] = "ReadOnly";
    AccessPermission[AccessPermission["ReadWrite"] = 6] = "ReadWrite";
})(AccessPermission || (AccessPermission = {}));
